export default __webpack_public_path__ + "static/media/onenote-2.7556c7d1.svg";